import { useMemo } from 'react';

import type { NotificationId } from '@/modules/api/codegen';
import { useUser } from '@/modules/auth/hooks';

export function useUserNotification(notificationId: NotificationId) {
    const user = useUser();

    const notification = useMemo(
        () => user?.notifications?.find(notification => notification.id === notificationId),
        [notificationId, user?.notifications],
    );

    return {
        isLoading: !user,
        notification,
    };
}
